module.exports = __webpack_public_path__ + "img/icon_3_20.0dfad40f.png";